import { apiClient } from '@/services/http';
import { RevokeOtherSessionsResponse, RevokeSessionResponse, Session } from '@/types';

export const sessionService = {
    list: (params?: Record<string, unknown>) =>
        apiClient.get<Session[], Record<string, unknown>>('/api/sessions', { params }),
    revoke: (id: string) => apiClient.delete<RevokeSessionResponse>(`/api/sessions/${id}`),
    revokeOthers: () => apiClient.post<RevokeOtherSessionsResponse>('/api/sessions/revoke-others'),
};
